import { useSnapshot } from 'hooks/use-safe-snapshot';
import { state } from 'state/default-region';

const useDefaultRegion = () => {
    const { defaultRegion } = useSnapshot(state);

    return defaultRegion;
};

export { useDefaultRegion };
